import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { userGroupService } from "../shared/api/userGroupService";
import { UserGroupFormState } from "../shared/types/userGroup";
import { UserMultiSelectField } from "../users/UserSelectField";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: UserGroupFormState) => {
		const errors: { [K in keyof UserGroupFormState]?: any } = {};

		if (!values.name) {
			errors.name = t("Required field");
		}

		return errors;
	};
};

const UserGroupFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="name" label={t("Name")} required />
			<UserMultiSelectField label={t("Users")} name="users" clearable={true} />
		</FormDrawerContent>
	);
};

export const UserGroupCreateDrawer: FC<CreateDrawerFormProps<UserGroupFormState>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const initialValues: UserGroupFormState = {
		name: null,
		users: [],
	};

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Create user group")}
			validate={validate}
			renderForm={(props) => <UserGroupFormDrawerContent {...props} />}
		/>
	);
};

export const UserGroupUpdateDrawer: FC<UpdateDrawerFormProps<UserGroupFormState>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...props}
			title={t("Edit user group")}
			queryFn={() => userGroupService.show(props.id).then((x) => x.data.data)}
			queryKey={userGroupService.showKey(props.id)}
			validate={validate}
			renderSuccess={(props) => <UserGroupFormDrawerContent {...props} />}
		/>
	);
};
